import { CuriosityComparison } from "./curiosities-config";
import { PERSON_HEIGHT_M, PERSON_IN_LINE_M, PERSON_SIDE_BY_SIDE_M } from "./constants";

export function calculateHeightCoverage(
	totalPeople: number,
	targetHeightM: number,
): number {
	const totalHeight = totalPeople * PERSON_HEIGHT_M;
	return totalHeight / targetHeightM;
}

export function calculateDistanceSideBySideCoverage(
	totalPeople: number,
	targetDistanceM: number,
): number {
	const totalDistance = totalPeople * PERSON_SIDE_BY_SIDE_M;
	return totalDistance / targetDistanceM;
}

export function calculateDistanceInLineCoverage(
	totalPeople: number,
	targetDistanceM: number,
): number {
	const totalDistance = totalPeople * PERSON_IN_LINE_M;
	return totalDistance / targetDistanceM;
}

export function calculateOneToOneCoverage(totalPeople: number, capacity: number): number {
	return totalPeople / capacity;
}

export function calculateComparisonValue(
	comparison: CuriosityComparison,
	totalPeople: number,
	operatingTime?: { daysOfOperation: number; minutesInYear: number; hoursWorked: number },
	qtdLitrosCervejas?: number,
): number {
	switch (comparison.type) {
		case "height":
			return calculateHeightCoverage(totalPeople, comparison.value);
		case "distance-side-by-side":
			return calculateDistanceSideBySideCoverage(totalPeople, comparison.value);
		case "distance-in-line":
			return calculateDistanceInLineCoverage(totalPeople, comparison.value);
		case "one-to-one":
			// Usar dados dinâmicos da API para relogio e calendario
			if (comparison.id === "relogio" && operatingTime?.minutesInYear) {
				return calculateOneToOneCoverage(totalPeople, operatingTime.minutesInYear);
			}
			if (comparison.id === "calendario" && operatingTime?.daysOfOperation) {
				return calculateOneToOneCoverage(totalPeople, operatingTime.daysOfOperation);
			}
			// Viagem ao Japão usa horas trabalhadas
			if (comparison.id === "japao" && operatingTime?.hoursWorked) {
				return calculateOneToOneCoverage(operatingTime.hoursWorked, comparison.value);
			}
			if (
				(comparison.id === "piscina" || comparison.id === "caminhaoTanque") &&
				qtdLitrosCervejas
			) {
				return calculateOneToOneCoverage(qtdLitrosCervejas, comparison.value);
			}
			return calculateOneToOneCoverage(totalPeople, comparison.value);
		default:
			return 0;
	}
}

export function calculateScore(value: number): number {
	if (value <= 0) return 0;

	// Range ideal: 1.5 a 50 = score máximo (valores mais interessantes)
	if (value >= 1.5 && value <= 50) return 1;

	// Valores entre 0.5 e 1.5: score médio-alto (quanto mais próximo de 1.5, melhor)
	if (value >= 0.5 && value < 1.5) {
		return 0.6 + (value - 0.5) * 0.4; // 0.6 até 1.0
	}

	// Valores entre 50 e 100: score médio (quanto mais próximo de 50, melhor)
	if (value > 50 && value <= 100) {
		return 0.6 - ((value - 50) / 50) * 0.3; // 0.6 até 0.3
	}

	// Valores muito pequenos (< 0.5): quanto menor, pior
	if (value < 0.5) {
		return Math.max(0.05, value * 0.4); // Mínimo 0.05, máximo ~0.2
	}

	// Valores muito grandes (> 100): quanto maior, pior
	// Decaimento proporcional: 200x é melhor que 300x, que é melhor que 400x
	if (value > 100) {
		return Math.max(0.01, 0.3 / (1 + (value - 100) / 100));
	}

	return 0;
}
